import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { Shared, UserService } from '@rubii/frontend-common';

@Component({
  selector: 'app-pinterest',
  templateUrl: './pinterest.component.html',
  styleUrls: ['./pinterest.component.scss']
})
export class PinterestComponent extends BaseDatasourceComponent implements OnInit {

  pinterestEmail = '';

  constructor(private user: UserService) {
    super();
  }

  ngOnInit() {
    this.pinterestEmail = 'report+pinterest+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }

}
